// Funzione che restituisce lo status di un device dato il tipo
export const getDeviceStatus = (
  deviceState: any[] | null | undefined,
  type: string
) => {
  if (!deviceState) return undefined;
  const device = deviceState.find(device => device.type === type);
  return device ? device.status : undefined;
};
